import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { Badge } from "../../ui/badge";
import { ScrollArea } from "../../ui/scroll-area";

interface ReviewDiffModalProps {
  isOpen: boolean;
  onClose: () => void;
  original: string;
  correction: string | null;
  requestId: string;
}

const ReviewDiffModal: React.FC<ReviewDiffModalProps> = ({
  isOpen,
  onClose,
  original,
  correction,
  requestId,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl max-h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            Review Comparison
            <Badge variant="outline" className="font-mono font-normal text-xs">
              {requestId}
            </Badge>
          </DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 min-h-0 grid grid-cols-2 gap-4 mt-4">
          {/* Original */}
          <div className="flex flex-col min-h-0 border rounded-md bg-muted/10">
            <div className="p-3 border-b bg-muted/30 flex items-center justify-between">
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                Original Response
              </span>
            </div>
            <ScrollArea className="flex-1 p-4">
              <div className="whitespace-pre-wrap text-sm leading-relaxed">
                {original}
              </div>
            </ScrollArea>
          </div>

          {/* Correction */}
          <div className="flex flex-col min-h-0 border rounded-md bg-blue-50/30 dark:bg-blue-950/10 border-blue-100 dark:border-blue-900/30">
            <div className="p-3 border-b border-blue-100 dark:border-blue-900/30 bg-blue-50/50 dark:bg-blue-950/20 flex items-center justify-between">
              <span className="text-sm font-medium text-blue-700 dark:text-blue-400 uppercase tracking-wider">
                Corrected Response
              </span>
              <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-200 border-blue-200">
                New
              </Badge>
            </div>
            <ScrollArea className="flex-1 p-4">
              <div className="whitespace-pre-wrap text-sm leading-relaxed text-foreground">
                {correction || <span className="text-muted-foreground italic">No correction content available</span>}
              </div>
            </ScrollArea>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReviewDiffModal;
